import React from 'react';
import styles from './InputField.module.css';

const InputField = ({ id, type, label, classes, ...props }) => {
	return (
		<div className='form-floating mb-3'>
			<input
				{...props}
				id={id}
				type={type}
				className={`form-control ${styles.inputField} ${classes && classes}`}
				placeholder=''
			/>
			<label className={`${styles.label} fw-medium`} htmlFor={id}>
				{label}
			</label>
		</div>
	);
};

export default InputField;
